export default "__VITE_ASSET__0faf9e0b__"